angular.module('ikeweb.user').factory('loginTopics',

    function() {

        return {
            LOGIN: {
                COMPLETED: {
                    SUCCESS: {
                        name: 'login.completed.success'
                    }
                }
            }
        };
    });



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/login/login.topics.js
// module id = 468
// module chunks = 0